var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 711,
    height: 689.493,
    viewBox: "0 0 711 689.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M478.4,797.3l.6-272.8,186.7-67.9-.5,272.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M478.4,797.3l.7-231.4L665.7,456.6,665,688,478.4,797.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M399.9,403.9l-2.7-22.4,86.7-52,2.8,22.4Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create-company",
    transform: "translate(-144.515 -155.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    transform: "translate(-124.885 -155.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3094350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor-2",
    cx: 355.5,
    cy: 205.2,
    rx: 355.5,
    ry: 205.2,
    transform: "translate(269.4 590.4)",
    fill: "#c2eed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow-2",
    d: "M705.4,861.1c-28.8-11.5-28.8-30.1,0-41.6s75.8-11.5,104.6,0,28.8,30.1,0,41.6S734.2,872.6,705.4,861.1Z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow-3",
    d: "M355,868.7l-61.3-35.5c-3.5-2-3.5-5.3,0-7.2L650.4,620.1a13.771,13.771,0,0,1,12.5,0l61.3,35.5c3.5,2,3.5,5.3,0,7.2L367.5,868.7A13.771,13.771,0,0,1,355,868.7Z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    d: "M575.4,805.5,628.1,775c5.4-3.2,8.1-7.2,8.1-11.3v-7.4l-54.6-30.8a11.627,11.627,0,0,1-5.3-9.1v-65l-92,53.3v65a11.785,11.785,0,0,0,5.3,9.1l46.5,26.9C546.9,811.9,564.6,811.9,575.4,805.5Z",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    d: "M575.4,805.5,628.1,775c5.4-3.2,8.1-7.2,8.1-11.3v-7.4l-54.6-30.8a11.627,11.627,0,0,1-5.3-9.1v-65l-92,53.3v65a11.785,11.785,0,0,0,5.3,9.1l46.5,26.9C546.9,811.9,564.6,811.9,575.4,805.5Z",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    d: "M506.5,781.2v7.2l-16.9-9.7a11.627,11.627,0,0,1-5.3-9.1v-65l17.5-10.1c.3,4.5.8,9.1,1.1,13.6l-12.4,7.1V766a11.368,11.368,0,0,0,5.3,9.1Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    d: "M490.6,766a11.785,11.785,0,0,0,5.3,9.1L536,798.2c10.9,6.3,28.5,6.3,39.4,0l52.8-30.5c10.9-6.3,10.9-16.4,0-22.8l-40.1-23.1a11.627,11.627,0,0,1-5.3-9.1V661.9l-92,53.3V766Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    d: "M490.6,766a11.785,11.785,0,0,0,5.3,9.1L536,798.2c10.9,6.3,28.5,6.3,39.4,0l52.8-30.5c10.9-6.3,10.9-16.4,0-22.8l-40.1-23.1a11.627,11.627,0,0,1-5.3-9.1V661.9l-92,53.3V766Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    d: "M598.7,728.1h0L588,721.9a11.627,11.627,0,0,1-5.3-9.1V662l-92,53.3v50.8a11.785,11.785,0,0,0,5.3,9.1l10.6,6Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    d: "M636.2,756.5v7.4c0,4.1-2.7,8.1-8.1,11.3l-52.7,30.5c-5.3,3-11.9,4.5-18.7,4.7v-7.2c6.8-.2,13.6-1.7,18.7-4.7L628.1,768C633.5,764.6,636.2,760.6,636.2,756.5Z",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    d: "M636.2,756.5v7.4c0,4.1-2.7,8.1-8.1,11.3l-52.7,30.5c-5.3,3-11.9,4.5-18.7,4.7v-7.2c6.8-.2,13.6-1.7,18.7-4.7L628.1,768C633.5,764.6,636.2,760.6,636.2,756.5Z",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    d: "M342.8,829.2c3.5,2,9.1,1.8,12.7-.3,45.3-26.1,310.8-179.4,356.1-205.5a14.646,14.646,0,0,0,6.5-11.3V323.9c0-4.2-2.7-9.2-6.2-11.2s-9.1-1.8-12.7.3L343.1,518.7a14.646,14.646,0,0,0-6.5,11.3V818C336.7,822.3,339.4,827.3,342.8,829.2Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    d: "M355.6,828.9,711.7,623.4a14.646,14.646,0,0,0,6.5-11.3V323.9c0-4.2-2.9-5.9-6.5-3.8L355.6,525.8a14.646,14.646,0,0,0-6.5,11.3v288C349,829.4,352,831,355.6,828.9Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    d: "M355.6,828.9,711.7,623.4a14.646,14.646,0,0,0,6.5-11.3V323.9c0-4.2-2.9-5.9-6.5-3.8L355.6,525.8a14.646,14.646,0,0,0-6.5,11.3v288C349,829.4,352,831,355.6,828.9Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    d: "M354.5,836.5a12.385,12.385,0,0,1-18-11.5V798.7l12.4,7.1v26.3C349,836,351.4,837.7,354.5,836.5Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    d: "M354.5,836.5a12.385,12.385,0,0,1-18-11.5V798.7l12.4,7.1v26.3C349,836,351.4,837.7,354.5,836.5Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    d: "M349,805.8v26.3c0,4.2,2.9,5.9,6.5,3.8L711.6,630.4a14.646,14.646,0,0,0,6.5-11.3V592.9Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    d: "M349,805.8v26.3c0,4.2,2.9,5.9,6.5,3.8L711.6,630.4a14.646,14.646,0,0,0,6.5-11.3V592.9Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    d: "M361.3,772.9V541a8.5,8.5,0,0,1,3.9-6.8L701.8,339.9c2.1-1.2,3.9-.3,3.9,2.3V574.1a8.5,8.5,0,0,1-3.9,6.8L365.2,775.2C363,776.6,361.3,775.5,361.3,772.9Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    d: "M361.3,772.9V541a8.5,8.5,0,0,1,3.9-6.8L701.8,339.9c2.1-1.2,3.9-.3,3.9,2.3V574.1a8.5,8.5,0,0,1-3.9,6.8L365.2,775.2C363,776.6,361.3,775.5,361.3,772.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    d: "M533.6,707.6a13.551,13.551,0,0,0-6.2,10.7c0,3.9,2.7,5.6,6.2,3.6a13.551,13.551,0,0,0,6.2-10.7C539.7,707.3,536.9,705.6,533.6,707.6Z",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    d: "M350.9,530.6a13.742,13.742,0,0,0-2,6.5V806l-12.4-7.1.2-268.9a13.742,13.742,0,0,1,2-6.5Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    d: "M718.1,322.9c-.5-3.3-3.2-4.7-6.5-2.7l-356,205.6a15.383,15.383,0,0,0-4.7,4.8l-12.4-7.1a14.391,14.391,0,0,1,4.7-4.8L699.3,313.2c3.6-2.1,9.4-2.3,12.7-.3C715.1,314.6,717.7,318.9,718.1,322.9Z",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M737.3,358.3a3.265,3.265,0,0,0-3.3.3L398,552.5a10.065,10.065,0,0,0-4.5,8V790.9a4.086,4.086,0,0,0,2,3.9c.8.5,4.7,2.7,5.9,3.3a2.419,2.419,0,0,0,2.7-.2l336-194a10.065,10.065,0,0,0,4.5-8V364.5a3.25,3.25,0,0,0-1.4-3C742.1,361,738.2,358.8,737.3,358.3Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M402.4,797.8c-1.4,0-2.3-1.5-2.3-3.5V563.8a8.958,8.958,0,0,1,4.2-7.2l335.9-194a4.8,4.8,0,0,1,1.7-.5c1.1,0,1.8.9,1.8,2.6V596.3a8.958,8.958,0,0,1-4.2,7.2l-336,194A2.607,2.607,0,0,1,402.4,797.8Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M741.8,362.8h0c.9,0,1.1,1.1,1.1,1.8V596.2a8.727,8.727,0,0,1-3.8,6.6l-336,193.9a6.892,6.892,0,0,1-.8.3c-.9,0-1.5-1.4-1.5-2.7V563.8a8.728,8.728,0,0,1,3.8-6.6l336-194a5.639,5.639,0,0,1,1.2-.4m0-1.5a3.936,3.936,0,0,0-2.1.6L403.9,556a10.065,10.065,0,0,0-4.5,8V794.4c0,2.3,1.4,4.2,3,4.2a2.7,2.7,0,0,0,1.5-.5l336-194a10.065,10.065,0,0,0,4.5-8V364.5c0-2.1-1.1-3.2-2.6-3.2Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    d: "M395.3,795c.5.3,4.1,2.3,5.6,3.2a4.6,4.6,0,0,1-1.7-3.9V578.9l-5.9-3.5V790.9A4.593,4.593,0,0,0,395.3,795Z",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    d: "M744.4,364.5c0-2.9-2.1-4.1-4.5-2.6l-336,194a10.065,10.065,0,0,0-4.5,8V579L744.5,379.5v-15Z",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M739.9,361.9l-336,194a9.83,9.83,0,0,0-3.2,3.5l-5.9-3.3a7.826,7.826,0,0,1,3.2-3.3L734,358.6a3.265,3.265,0,0,1,3.3-.3c.8.5,4.7,2.7,5.6,3.2C742.1,361,741.1,361.2,739.9,361.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    d: "M393.3,575.4V560.5a9.146,9.146,0,0,1,1.4-4.5l5.9,3.3a9.146,9.146,0,0,0-1.4,4.5v15.1Z",
    opacity: 0.15
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clouds-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    d: "M798.2,348.2,803,350V339.4c0-8.4,6.6-10.4,13.9-6.2h0c7.2,4.2,13.1,14.3,13.1,22.8v1.5a7.067,7.067,0,0,1,6,.9h0c5.3,3,9.5,10.4,9.5,16.4v.8l6.6,3.9a13.759,13.759,0,0,1,6.2,10.9c0,3.9-2.7,5.6-6.2,3.6L798,362.8a13.759,13.759,0,0,1-6.2-10.9C792,347.9,794.7,346.2,798.2,348.2Z",
    fill: "#e6e6e6",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    d: "M862.5,339.9l8.8,5v-3.8c0-4.5,3.2-6.3,7.1-4.1a14.925,14.925,0,0,1,4.2,4.1c.6-5.6,5.1-7.7,10.4-4.7,5.9,3.3,10.6,11.5,10.6,18.3v3.8a9.657,9.657,0,0,1-.9,4.4l7.2,4.2a8.5,8.5,0,0,1,3.9,6.8c0,2.4-1.8,3.5-3.9,2.3l-47.2-27.3a8.5,8.5,0,0,1-3.9-6.8C858.5,339.6,860.3,338.5,862.5,339.9Z",
    fill: "#e6e6e6",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    d: "M496.5,774.2l-1.7,1v6l1.7-1v-6m-2.4-7.5h.4a1.086,1.086,0,0,1,.4.9v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.1c-.4,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5h0m4.3-2.5h.4a1.086,1.086,0,0,1,.4.9v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.1c-.4,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5h0m-4.3-3.5h0c.4-.2.7.3.7,1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.3c-.3-.1-.4-.5-.4-1a2.518,2.518,0,0,1,.9-2l.9-.5.1-.1h0m4.3-2.5c.4-.2.7.3.7,1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.3c-.3-.1-.4-.5-.4-1a2.518,2.518,0,0,1,.9-2l.9-.5a.1.1,0,0,1,.1-.1h0m2.5-4.4-10.4,6.1-.1,23.8,2.6-1.5v-7.4a2.518,2.518,0,0,1,.9-2l3.5-2a.1.1,0,0,0,.1-.1h0c.1-.1.3,0,.4,0,.1.1.2.2.2.3a1.268,1.268,0,0,1,.1.6v7.5l2.6-1.5.1-23.8M496.6,732l-1.7,1v6l1.7-1v-6m-2.4-7.5h.4a.975.975,0,0,1,.4.9v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.2c-.3,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5c0,.1,0,0,.1,0h0m4.3-2.5h.4a.975.975,0,0,1,.4.9v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.2c-.3,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5h.1m-4.3-3.4h0a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.1c-.4,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5h.1m4.3-2.6h.4a.975.975,0,0,1,.4.9v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.1c-.4.1-.7-.3-.7-1.1a2.518,2.518,0,0,1,.9-2l.9-.5c0,.1.1,0,.1,0h0m2.5-4.4-10.4,6.1-.1,23.8,2.6-1.5v-7.4a2.518,2.518,0,0,1,.9-2l3.5-2h.2c.4-.2.8.3.7,1V737l2.6-1.5V711.6m-4.2-24.3-1.7,1v6l1.7-1v-6m-2.5-7.4a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.3c-.3-.1-.4-.5-.4-1a2.518,2.518,0,0,1,.9-2l.9-.5a.1.1,0,0,1,.1-.1h0m4.3-2.6h0a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.2c-.3,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5c.2.1.2.1.2,0h0m-4.3-3.4h.2c.3,0,.6.4.6,1.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1H493c-.3,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5a.1.1,0,0,0,.1-.1h0m4.4-2.5h0a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.3c-.3-.1-.4-.5-.4-1a2.518,2.518,0,0,1,.9-2l.9-.5c0-.1,0-.1.1-.1h0m2.5-4.5L490.8,673l-.1,23.8,2.6-1.5v-7.4a2.518,2.518,0,0,1,.9-2l3.5-2h.4c.3,0,.6.4.6,1.1v7.4l2.6-1.5-.1-24m.7,83.3h.4a.975.975,0,0,1,.4.9v.1l-.1,25.3.9-.5a.1.1,0,0,0,.1-.1h0c.4-.2.7.3.7,1a2.518,2.518,0,0,1-.9,2l-15.7,9.2a.1.1,0,0,0-.1.1h-.2c-.3,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5.1-25.3a2.518,2.518,0,0,1,.9-2l12.2-7.1c0,.1,0,0,.1,0h0m104.2-49.5a.9.9,0,0,1,.5-.1c.9,0,1.5,1,1.6,2.7v.2c0,2.2-1.1,4.7-2.4,5.4L513.4,763a.349.349,0,0,0-.2.1h-.1a.6.6,0,0,1-.4.1c-.9,0-1.6-1.1-1.6-2.9,0-2.2,1.1-4.7,2.4-5.4l92.4-54.1a.31.31,0,0,0,.2-.1h0M502,708h.4a.975.975,0,0,1,.4.9v.1l-.1,25.3.9-.5h.6a.975.975,0,0,1,.4.9v.1a2.518,2.518,0,0,1-.9,2L488,746a.1.1,0,0,0-.1.1h-.2c-.3,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5.1-25.3a2.518,2.518,0,0,1,.9-2l12.2-7.1c-.2,0-.1-.1-.1-.1h0m104.2-49.5c.1,0,.2-.1.3-.1.9-.1,1.6.9,1.7,2.5v.4c0,2.2-1.1,4.7-2.4,5.4l-92.4,54.1c-.1,0-.1.1-.2.1s-.1,0-.2.1h0c-.1,0-.2.1-.3.1-1,.2-1.8-1-1.8-2.9,0-2.2,1.1-4.7,2.4-5.4l92.4-54.1c.3-.1.4-.1.5-.2h0m-104,4.9h.4a.975.975,0,0,1,.4.9v.1l-.1,25.3.9-.5a.1.1,0,0,0,.1-.1h0a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2L488,701.3a.1.1,0,0,0-.1.1h-.2c-.3,0-.6-.4-.6-1.1a2.518,2.518,0,0,1,.9-2l.9-.5.1-25.3a2.518,2.518,0,0,1,.9-2l12.2-7.1h.1m104.2-49.5h0c.1,0,.2-.1.3-.1,1-.2,1.7.9,1.8,2.7v.2c0,2.3-1.1,4.7-2.4,5.5l-92.4,54.1a.367.367,0,0,1-.3.1h0c-.1,0-.2.1-.3.1-1,.1-1.7-1-1.7-2.9,0-2.2,1.1-4.7,2.4-5.4l92.4-54.1c.1,0,.1-.1.2-.1-.2-.1-.1-.1,0-.1h0m58.7-58.4-1.4.8a3.447,3.447,0,0,1-1.2,1.2l-180.8,106c-.1.1-.2.1-.4.2h-.1a.854.854,0,0,1-.7,0l-1.4.8-.4,132.6,93-54.5,93-54.5.4-132.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    d: "M496.9,631.4l-1.7,1v6l1.7-1v-6m-2.4-7.5h0a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1H493c-.3-.1-.4-.5-.4-1a2.518,2.518,0,0,1,.9-2l.9-.5c0-.1,0-.1.1-.1h0m4.3-2.5h0a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.3c-.3-.1-.4-.5-.4-1a2.518,2.518,0,0,1,.9-2l.9-.5.1-.1h0m-4.3-3.4h.4a.91.91,0,0,1,.4.8v.2a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.1c-.4.1-.7-.4-.7-1.1a2.518,2.518,0,0,1,.9-2l.9-.5h.1m4.3-2.6h.2c.1,0,.3.1.3.2a1.445,1.445,0,0,1,.2.7v.2a2.518,2.518,0,0,1-.9,2l-.9.5a.1.1,0,0,0-.1.1h-.1c-.4.1-.7-.4-.7-1.1a2.518,2.518,0,0,1,.9-2l.9-.5.2-.1h0m2.5-4.5L490.9,617l-.1,23.8,2.6-1.5v-7.4a2.518,2.518,0,0,1,.9-2l3.5-2h.5a1.234,1.234,0,0,1,.5.8v7.6l2.6-1.5-.1-23.9m1-3.5a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1l-.1,25.3.9-.5a.1.1,0,0,0,.1-.1h0a.419.419,0,0,1,.6.3,1.268,1.268,0,0,1,.1.6v.1a2.518,2.518,0,0,1-.9,2L488,645.3a.1.1,0,0,0-.1.1h-.1c-.4.1-.7-.4-.7-1.1a2.518,2.518,0,0,1,.9-2l.9-.5.1-25.3a2.518,2.518,0,0,1,.9-2l12.2-7.1h.2m104.2-49.5h0c.1,0,.1,0,.2-.1,1-.2,1.8.9,1.8,2.7v.2c0,2.3-1.1,4.7-2.4,5.5l-92.4,54.1a.349.349,0,0,0-.2.1h-.1c-.1,0-.2.1-.3.1-1,.1-1.7-1-1.7-2.9,0-2.2,1.1-4.7,2.4-5.4l92.4-54.1c.1-.1.2-.1.3-.2h0M656,528.4c.1,0,.3,0,.3.1a1.422,1.422,0,0,1,.2.6,1.883,1.883,0,0,1-.2.8l-3,7.2v.1a1,1,0,0,1-.4.5h-.1c-.1.1-.3,0-.4-.1l-3-3.7a1.422,1.422,0,0,1-.2-.6v-.1a1.613,1.613,0,0,1,.6-1.3h.1c.1,0,.2,0,.2.1h0l2.5,3.1,2.6-6.1h0c.3-.2.5-.4.8-.6h0m7-28.6h-.1c-.1,0-.1.1-.2.1l-180.8,106c-1.3.8-2.3,3.2-2.3,5.3l-.1,48.7v.1a3.071,3.071,0,0,0,1,2.6,1.183,1.183,0,0,0,1,.1c.1,0,.2-.1.3-.1L662.6,556.7c1.3-.8,2.3-3.1,2.3-5.3l.1-48.7c0-1.9-.8-3-1.8-2.8,0-.2-.1-.2-.2-.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    d: "M663,499.8h0a.349.349,0,0,0,.2-.1c1-.2,1.8.9,1.8,2.8l-.1,48.7c0,2.2-1.1,4.6-2.3,5.3l-180.9,106a.367.367,0,0,1-.3.1h0a1.184,1.184,0,0,1-1-.1,2.6,2.6,0,0,1-1-2.6v-.1l.1-48.7c0-2.2,1-4.6,2.3-5.3L662.7,499.9c.1,0,.2-.1.3-.1h0m.1-1a.758.758,0,0,0-.4.2L481.9,604.9c-1.6.9-2.8,3.8-2.9,6.5v14l-.1,34.8c0,2,.7,3.3,1.6,3.5.2.1.5,0,.7,0h.1a.758.758,0,0,0,.4-.2L662.5,557.6a3.447,3.447,0,0,0,1.2-1.2,10.43,10.43,0,0,0,1.7-5.4l.2-48.7c0-2.6-1.1-4-2.5-3.5",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    d: "M656,528.4h0a1.333,1.333,0,0,0-.5.6h0l-2.6,6.1-2.5-3.1h0c-.1-.1-.1-.1-.2-.1h-.1a1.612,1.612,0,0,0-.6,1.3v.1a.735.735,0,0,0,.2.6l3,3.7c.1.1.2.2.4.1h.1a1,1,0,0,0,.4-.5v-.1l3-7.2a2.354,2.354,0,0,0,.2-.8.735.735,0,0,0-.2-.6,2.144,2.144,0,0,0-.6-.1",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    d: "M494.5,623.9h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2,1.175,1.175,0,0,0,.4,1h.3a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6.419.419,0,0,0-.6-.3m4.3-2.6h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2,1.175,1.175,0,0,0,.4,1h.3a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6.486.486,0,0,0-.6-.3m-4.3-3.4h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.3,1.1.7,1.1h.1a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.2a.91.91,0,0,0-.4-.8.6.6,0,0,0-.4-.1m4.4-2.5a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.3,1.1.7,1.1h.1a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.2a1.854,1.854,0,0,0-.2-.7c-.1-.1-.2-.2-.3-.2h-.3m-3.7,22.9v-6l1.7-1v6l-1.7,1m-4.4,2.6.1-23.8,10.4-6.1-.1,23.8-2.6,1.5v-7.6c0-.5-.2-.8-.5-.8h-.5l-3.5,2a2.518,2.518,0,0,0-.9,2v7.4l-2.4,1.6m11.6-33.5h0a.1.1,0,0,0-.1.1l-12.2,7.1a2.518,2.518,0,0,0-.9,2l-.1,25.3-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.3,1.1.7,1.1h.1a.1.1,0,0,0,.1-.1l15.7-9.2a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6.446.446,0,0,0-.6-.3h0a.1.1,0,0,0-.1.1l-.9.5.1-25.3v-.1a1.268,1.268,0,0,0-.1-.6c-.3-.4-.5-.5-.7-.4",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    d: "M606.5,557.9h0c-.2.1-.2.1-.3.1l-92.4,54.1c-1.3.8-2.4,3.2-2.4,5.4,0,1.9.7,3,1.7,2.9a.367.367,0,0,0,.3-.1h.1a.349.349,0,0,0,.2-.1l92.4-54.1c1.3-.8,2.4-3.2,2.4-5.5v-.2c0-1.8-.8-2.9-1.8-2.7a.215.215,0,0,1-.2.2",
    fill: "#e0f6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    d: "M494.3,679.9h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2,1.175,1.175,0,0,0,.4,1h.3a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6.419.419,0,0,0-.6-.3m4.4-2.6h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.6.2,1,.6,1.1h.2a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6c-.2-.3-.5-.5-.7-.4m-4.4-3.4a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.2,1.1.6,1.1h.2a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2c0-.7-.2-1.1-.6-1.1h-.2m4.4-2.5h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2,1.175,1.175,0,0,0,.4,1h.3a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6.446.446,0,0,0-.6-.3M495,694.3v-6l1.7-1v6l-1.7,1m6.2-27.4-.1,23.8-2.6,1.5v-7.4c0-.7-.2-1.1-.6-1.1h-.4l-3.5,2a2.518,2.518,0,0,0-.9,2v7.4l-2.6,1.5.1-23.8,10.6-5.9m1-3.5h0c-.1,0-.1,0-.1.1l-12.2,7.1a2.518,2.518,0,0,0-.9,2l-.1,25.3-.9.5a2.518,2.518,0,0,0-.9,2c0,.6.2,1,.6,1.1h.2a.1.1,0,0,0,.1-.1l15.7-9.2a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6.446.446,0,0,0-.6-.3h0a.1.1,0,0,0-.1.1l-.9.5.1-25.3v-.1a1.086,1.086,0,0,0-.4-.9c-.2-.2-.3-.2-.4-.1",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    d: "M606.4,613.9h0c-.1,0-.1.1-.2.1s-.1.1-.2.1l-92.4,54.1c-1.3.8-2.4,3.2-2.4,5.4,0,1.9.7,3,1.7,2.9a.367.367,0,0,0,.3-.1h0c.1,0,.2-.1.3-.1l92.4-54.1c1.3-.8,2.4-3.2,2.4-5.5v-.2c0-1.8-.8-2.8-1.8-2.7.1,0,0,0-.1.1",
    fill: "#e0f6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    d: "M494.2,724.5h0c-.1,0-.1,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.6.2,1,.6,1.1h.2a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a1.086,1.086,0,0,0-.4-.9.756.756,0,0,0-.4-.1m4.3-2.5h0c-.1,0-.1,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.6.2,1,.6,1.1h.2a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2V723a1.086,1.086,0,0,0-.4-.9.247.247,0,0,0-.4-.1m-4.3-3.4h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.3,1.1.6,1.1h.1a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a1.268,1.268,0,0,0-.1-.6c-.1-.4-.3-.5-.6-.4m4.3-2.6h0c-.1,0-.1,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.3,1.1.7,1.1h.1a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2V717a1.086,1.086,0,0,0-.4-.9c-.1-.1-.2-.1-.4-.1m-3.6,23v-6l1.7-1v6l-1.7,1m6.2-27.4-.1,23.8-2.6,1.5v-7.4c0-.8-.3-1.2-.7-1h-.2l-3.5,2a2.518,2.518,0,0,0-.9,2v7.4l-2.6,1.5.1-23.8,10.5-6m.9-3.6h0c-.1,0-.1,0-.1.1l-12.2,7.1a2.518,2.518,0,0,0-.9,2l-.1,25.3-.9.5a2.518,2.518,0,0,0-.9,2c0,.6.2,1,.6,1.1h.2a.1.1,0,0,0,.1-.1l15.7-9.2a2.518,2.518,0,0,0,.9-2v-.1a1.086,1.086,0,0,0-.4-.9c-.1-.1-.2-.1-.4,0h-.2l-.9.5.1-25.3v-.1a1.086,1.086,0,0,0-.4-.9H502",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    d: "M606.2,658.5h0c-.2.1-.2.1-.3.1l-92.4,54.1c-1.3.8-2.4,3.2-2.4,5.4,0,1.9.8,3,1.8,2.9a.367.367,0,0,0,.3-.1h0a.31.31,0,0,0,.2-.1c.1,0,.1-.1.2-.1L606,666.6c1.3-.8,2.4-3.2,2.4-5.4v-.4c-.1-1.6-.8-2.6-1.7-2.5a1.691,1.691,0,0,1-.5.2",
    fill: "#e1f5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    d: "M494.1,766.7a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.3,1.1.6,1.1h.1a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a.975.975,0,0,0-.4-.9.367.367,0,0,0-.3-.1m4.3-2.5h0c-.1,0-.1,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2c0,.7.3,1.1.6,1.1h.1a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2v-.1a.975.975,0,0,0-.4-.9c0-.2-.2-.2-.3-.1m-4.3-3.5h0a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2,1.175,1.175,0,0,0,.4,1h.3a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2c0-.7-.3-1.1-.7-1m4.3-2.5a.1.1,0,0,0-.1.1l-.9.5a2.518,2.518,0,0,0-.9,2,1.175,1.175,0,0,0,.4,1h.3a.1.1,0,0,0,.1-.1l.9-.5a2.518,2.518,0,0,0,.9-2c.1-.7-.3-1.2-.7-1m-3.6,22.9v-6l1.7-1v6l-1.7,1m6.1-27.3-.1,23.8-2.6,1.5v-7.5a1.268,1.268,0,0,0-.1-.6c0-.1-.1-.2-.2-.3a.3.3,0,0,0-.4,0h0a.1.1,0,0,0-.1.1l-3.5,2a2.518,2.518,0,0,0-.9,2v7.4l-2.6,1.5.1-23.8,10.4-6.1m1-3.6h0c-.1,0-.1,0-.1.1l-12.2,7.1a2.518,2.518,0,0,0-.9,2l-.1,25.3-.9.5a2.518,2.518,0,0,0-.9,2c0,.6.2,1,.6,1.1h.2a.1.1,0,0,0,.1-.1l15.7-9.2a2.518,2.518,0,0,0,.9-2c0-.8-.3-1.2-.7-1h0a.1.1,0,0,0-.1.1l-.9.5.1-25.3v-.1a1.086,1.086,0,0,0-.4-.9.6.6,0,0,0-.4-.1",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    d: "M606.1,700.7h0c-.2.1-.2.1-.3.1L513.4,755c-1.3.8-2.4,3.2-2.4,5.4,0,1.8.7,2.9,1.6,2.9a.6.6,0,0,0,.4-.1h.1a.349.349,0,0,0,.2-.1L605.7,709c1.3-.8,2.4-3.2,2.4-5.4v-.2c0-1.7-.7-2.7-1.6-2.7-.1-.1-.2-.1-.4,0",
    fill: "#dfe9f9"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    d: "M806.8,608.7s-25.8-3.2-64.9,7.5c0,0-6.3-69.8-5.5-79.4s60.3-6.8,60.3-6.8,1.5,28,5.4,44.8C805.9,591.6,808.7,605.4,806.8,608.7Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    d: "M806.8,608.7s-25.8-3.2-64.9,7.5c0,0-6.3-69.8-5.5-79.4s60.3-6.8,60.3-6.8,1.5,28,5.4,44.8C805.9,591.6,808.7,605.4,806.8,608.7Z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    d: "M723,839.9l10.5,3,2.5-16.4,1.3-8.8-10.5-3L725,826.4Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    d: "M783.5,840.8l10.8,1.4.1-15.7.1-9.8-10.9-1.4-.1,11.2Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    d: "M783.7,815.3l-.1,11.2h10.9l.1-9.8Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    d: "M725.1,826.5h11l1.3-8.8-10.5-3Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    d: "M676.3,542.4l-10.4-3.1,1.9,11.9s9.5,2.2,10.4-2.7Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    d: "M655.5,542l5.1,9.7,7.2-.5-1.9-11.9Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    d: "M690.7,545.4l-17.2-3.8-1.6,8.3,15.6,3.8Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    d: "M742.7,537.9a12.244,12.244,0,0,0-1,1.2c-2.2,2.5-7.5,8.7-12.9,13.9-4.4,4.3-8.9,8-11.9,8.8C708.5,564,678,555,678,555l3.2-12.4s28.4,3.8,30.7,3.8c1.7,0,19-25.1,23.2-27.1Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    d: "M741.6,539.1c-2.2,2.5-7.5,8.7-12.9,13.9,1.1-8.7,4.3-16.7,8.5-21.7a7.993,7.993,0,0,1,1.3-1.3Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    d: "M723.2,838.3l11.9-.3a1.2,1.2,0,0,1,1,.7l2.5,9.6a1.6,1.6,0,0,1-1.1,1.9c-.1,0-.3.1-.4.1-4.3,0-10.5,0-16,.1-6.3.2-10.4-.1-17.8.1-4.5.1-5.9-4.4-4-4.8,8.5-2.1,14-1.7,21.3-6.4A3.541,3.541,0,0,1,723.2,838.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    d: "M722.1,839.8h0c-1.8.4-4.9.9-6.1-.1a1.217,1.217,0,0,1-.5-1.2.842.842,0,0,1,.4-.7c1.3-.8,5.8,1.3,6.3,1.6a.192.192,0,0,1,.1.3A.349.349,0,0,1,722.1,839.8Zm-5.9-1.6h0c-.2.1-.3.2-.2.3a1.135,1.135,0,0,0,.3.8c.7.6,2.5.6,4.9.2C719.5,838.7,717,837.8,716.2,838.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    d: "M722.1,839.8h-.2c-1.3-.6-4-2.8-3.9-4.1,0-.3.2-.7.9-.7a2.146,2.146,0,0,1,1.5.4c1.4,1.1,1.8,4,1.8,4.2.1,0,.1.1-.1.2Zm-3.3-4.3c-.2.1-.2.2-.2.2-.1.7,1.8,2.5,3.1,3.3-.2-.9-.6-2.6-1.6-3.3a1.431,1.431,0,0,0-1.1-.3C719,835.5,718.9,835.5,718.8,835.5Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    d: "M783.9,838.3l11.9-.3a1.2,1.2,0,0,1,1,.7l2.5,9.6a1.6,1.6,0,0,1-1.1,1.9c-.1,0-.3.1-.4.1-4.3,0-10.5,0-16,.1-6.3.2-10.4-.1-17.8.1-4.5.1-5.9-4.4-4-4.8,8.5-2.1,14-1.7,21.3-6.4A3.876,3.876,0,0,1,783.9,838.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    d: "M782.9,839.8h0c-1.8.4-4.9.9-6.1-.1a1.217,1.217,0,0,1-.5-1.2.842.842,0,0,1,.4-.7c1.3-.8,5.8,1.3,6.3,1.6a.192.192,0,0,1,.1.3A.349.349,0,0,1,782.9,839.8Zm-5.9-1.6h0c-.2.1-.3.2-.2.3a1.135,1.135,0,0,0,.3.8c.7.6,2.5.6,4.9.2C780.3,838.7,777.8,837.8,777,838.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    d: "M782.9,839.8h-.2c-1.3-.6-4-2.8-3.9-4.1,0-.3.2-.7.9-.7a2.146,2.146,0,0,1,1.5.4c1.4,1.1,1.8,4,1.8,4.2.1,0,.1.1-.1.2Zm-3.3-4.3c-.2.1-.2.2-.2.2-.1.7,1.8,2.5,3.1,3.3-.2-.9-.6-2.6-1.6-3.3a1.431,1.431,0,0,0-1.1-.3c0,.1-.1.1-.2.1Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    d: "M805.9,602.3c5.7,24.9-4.1,220.9-4.1,220.9H782.7l-8.1-163.3-30,163.3-20.4-1.5c13.3-126.5,25.1-202,25.1-202v-9.5Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    d: "M795.6,510a236.581,236.581,0,0,0,.9,35.7c.8,8.3,1.9,16.1,3.1,23.2,2.7,16.6,5.9,29,6.3,33.3-8.3,1.1-39.6,5.5-56.6,7.8-20.7-57.8-12.9-91.4-12.9-91.4a116.863,116.863,0,0,1,13-4.4,24.605,24.605,0,0,1,2.9-.7c6.3-1.5,16.8-2.7,24.1-3.3,1.5-.1,3.1-.2,4.6-.3C788.7,509.6,795.6,510,795.6,510Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    d: "M765.3,484c.4,7.9,1.3,22.8,7.8,26.6,0,0-4.1,7.8-13,8.6-6.7.6-6.3-6-6.3-6,3.9-2.9,3-7.8,0-13.3Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    d: "M760.7,490.5l-6.8,9.4a28.745,28.745,0,0,1,1.8,4c3.1-1.2,6.7-5.9,6.2-9.3A13.9,13.9,0,0,0,760.7,490.5Z",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    d: "M736.4,468.1c-1.3,4.1-.6,12.6,5.2,9.8S738.6,461,736.4,468.1Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    d: "M766,473.6c.6,10.6,1.5,16.7-3.1,22.7-7,9-20.6,5.6-24.4-4.6-3.4-9.2-3.9-24.9,5.9-30.2a14.543,14.543,0,0,1,19.8,5.9A13.862,13.862,0,0,1,766,473.6Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    d: "M758.6,467.9V456.1s12.6-.9,12,5.5c7,3.5,3.7,14.3-5.7,19.6-5.1-4.1-4.5-14-4.5-14A17.069,17.069,0,0,1,758.6,467.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    d: "M771.2,481.9a10.027,10.027,0,0,1-4.2,6.4c-2.9,1.9-5.5-.4-5.6-3.8-.1-3,1.3-7.6,4.7-8.2C769.4,475.7,771.7,478.7,771.2,481.9Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    d: "M750.4,478.4c.1.9-.3,1.6-.8,1.7s-1.1-.6-1.2-1.4.3-1.6.8-1.7S750.3,477.5,750.4,478.4Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    d: "M740.8,479.4c.1.9-.3,1.6-.8,1.7s-1.1-.6-1.2-1.4.3-1.6.8-1.7S740.6,478.6,740.8,479.4Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    d: "M743.9,479.5s-1.4,5-3.3,7.5c1.7,1.2,4.2.2,4.2.2Z",
    fill: "#ffb797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    d: "M749.7,490a4.253,4.253,0,0,1-1.1.2c-.1,0-.3-.1-.3-.2s.1-.3.2-.3h0a6.624,6.624,0,0,0,5.2-3.3c.1-.1.2-.2.3-.1s.2.2.1.3h0A6.123,6.123,0,0,1,749.7,490Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    d: "M753,474.9a.749.749,0,0,1-.5-.1,3.993,3.993,0,0,0-3.4-1.3c-.3.1-.5-.1-.6-.4s.1-.5.4-.6h0a5,5,0,0,1,4.3,1.6.483.483,0,0,1,0,.7h0A.35.35,0,0,1,753,474.9Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    d: "M736.2,476.6a.441.441,0,0,1-.6-.4v-.3a4.82,4.82,0,0,1,3.3-3.2c.3-.1.5.1.6.4s-.1.5-.4.6h0a4.2,4.2,0,0,0-2.6,2.6C736.5,476.4,736.3,476.5,736.2,476.6Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    d: "M764.2,472.3s-7.4-2.7-10.8-7c0,0-6.7,1.8-8.1,4.5a3.4,3.4,0,0,1-.6-4.5s-5,1.1-6,4.5c0,0-2.5-.9-2.4-4.5,0,0-2.2.8-3,4.5,0,0-5.6-11.6,12.8-14.9a12.511,12.511,0,0,0-4.3-.7s12.8-5.2,23-.4S773.2,467.5,764.2,472.3Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    d: "M810.3,612.3l-17.8,2.4s-7.3-51.3-10.6-67.8V511.5l9.3-2.4,7.2,2.4a159.316,159.316,0,0,1,4.5,21.6c.9,5.5,1.7,11.5,2.4,17.5,1,8.2,1.8,16.5,2.4,24.3,1.1,12.6,1.8,23.7,2.2,30.5C810.1,609.7,810.3,612.3,810.3,612.3Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    d: "M781.9,546.8s1.5-24.9,9.3-37.8c0,0-.2-3.7-1.8-4.3s-7.5,2.9-7.5,2.9-3.7-2.5-4.5-1.4S774.6,515.4,781.9,546.8Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    d: "M781.9,546.8s1.5-24.9,9.3-37.8c0,0-.2-3.7-1.8-4.3s-7.5,2.9-7.5,2.9-3.7-2.5-4.5-1.4S774.6,515.4,781.9,546.8Z",
    fill: "#effaf4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    d: "M741.5,619.1l2,1.5s-2.9-16.5-1.7-58.3c.1-2,.1-4,.2-5.8,1.5-35.4,7-41.8,7.3-42.2l-5.1,1.7-9.3,3.2C732.2,549.4,741.5,619.1,741.5,619.1Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    d: "M742.3,550.4s-5.1-24.2-3.6-32.6,7-4.6,7-4.6,5-4.1,6.5.4C752.2,513.6,745.3,518.4,742.3,550.4Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    d: "M742.3,550.4s-5.1-24.2-3.6-32.6,7-4.6,7-4.6,5-4.1,6.5.4C752.2,513.6,745.3,518.4,742.3,550.4Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    d: "M805.3,550.6c-7.6-4.3-8.6-15.3-8.6-15.3.5-.2,3.3-1.1,6.2-2.1C803.8,538.6,804.6,544.6,805.3,550.6Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    d: "M768.2,694.6l6.4-34.7-1.2-18.4C773.3,641.5,764.6,673.4,768.2,694.6Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    d: "M809.9,605.4c-4.8-.3-8.9-.6-8.9-.6l-.9-19.4s1.5-1.3,5-.9a52.594,52.594,0,0,0,2.7-9.6C808.8,587.5,809.5,598.6,809.9,605.4Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    d: "M811.5,574.9l-9.3,14.9,7.3,4.2,8.7-13.4Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    d: "M798,511.3c6.3.7,32.8,37.2,34,48.2s-15.6,30-15.6,30l-11.2-6.6s11.4-17.5,12-22.2-20.8-23.8-20.8-23.8a42.661,42.661,0,0,1-2.6-13.7C793.4,515,798,511.3,798,511.3Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    d: "M800.1,585.4s9.6,2.1,13.4,8.1c0,0-4,12.5-6.8,13.9s-10,1.4-10,1.4S796.2,594.7,800.1,585.4Z",
    fill: "#36c96d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M400.7,379.4a4.077,4.077,0,0,0-1.7,2.1,15.751,15.751,0,0,0-.9,3.6,24.045,24.045,0,0,0,.1,4.6l.1,1a13.366,13.366,0,0,0,1.6,5.5,1.934,1.934,0,0,0,2.8.7,5.4,5.4,0,0,0,2.2-3,12.771,12.771,0,0,0,.5-4.9l-1.7,1a6.856,6.856,0,0,1-.2,2.6,3.269,3.269,0,0,1-1.1,1.5c-.6.4-1.1.2-1.4-.5a11,11,0,0,1-.9-3.8l-.2-1.3a14.477,14.477,0,0,1,0-4.2,2.943,2.943,0,0,1,1.1-2,1.049,1.049,0,0,1,1.3,0,3.892,3.892,0,0,1,.7,2.1l1.7-1a6.415,6.415,0,0,0-1.6-3.8,1.831,1.831,0,0,0-2.4-.2",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M408.5,379.4a3.521,3.521,0,0,0-1.2,2.6l-.2-1.5-1.6.9,1.5,12.7,1.6-1-1-8.3c.1-1,.4-1.7,1.1-2l.6-.3-.4-3.3c0,.1-.2.1-.4.2",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M411.9,383.2a7.165,7.165,0,0,1,.2-2.2,1.761,1.761,0,0,1,.7-1.2.642.642,0,0,1,.9.1,3.726,3.726,0,0,1,.5,1.6v.3l-2.3,1.4m.5-6.1a3.487,3.487,0,0,0-1.4,1.7,8.238,8.238,0,0,0-.7,2.9,14.6,14.6,0,0,0,.1,3.6v.3a7.539,7.539,0,0,0,1.4,4.1,1.747,1.747,0,0,0,2.4.4,3.531,3.531,0,0,0,1.3-1.4,6.9,6.9,0,0,0,.8-2.3l-1-1.4a3.218,3.218,0,0,1-1.3,2.3.9.9,0,0,1-1.1-.1,3,3,0,0,1-.7-1.7l3.9-2.4-.2-1.4a8.622,8.622,0,0,0-1.3-4.2,1.5,1.5,0,0,0-2.2-.4",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M419.6,384.1c-.2.1-.5.1-.6-.1a1.222,1.222,0,0,1-.3-.9v-.2a2.445,2.445,0,0,1,1.1-2.5l.6-.4.3,2.2-.3,1.2c-.4.3-.6.6-.8.7m-1-10.7a5.346,5.346,0,0,0-1.3,1.3,5.989,5.989,0,0,0-.8,2,8.3,8.3,0,0,0-.1,2.2l1.6-1a2.769,2.769,0,0,1,.1-1.3,1.242,1.242,0,0,1,.6-.8.521.521,0,0,1,.8.1,3.323,3.323,0,0,1,.4,1.3l.1.7-.8.5a4.751,4.751,0,0,0-2,2.4,7.872,7.872,0,0,0-.4,3.5,3.8,3.8,0,0,0,.9,2.4,1.226,1.226,0,0,0,1.6.2,3.957,3.957,0,0,0,1.4-2.3,6.218,6.218,0,0,0,.3,1l1.7-1v-.2a14.555,14.555,0,0,1-.6-2.6l-.7-5.5a4.631,4.631,0,0,0-1.1-2.9c-.3-.4-.9-.5-1.7,0",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M424,367.1l-1.6,1,.4,3.1-.9.5.3,2.5.9-.5.8,6.8c.3,2.4,1,3.2,2.2,2.5a4.064,4.064,0,0,0,1-.9l-.3-2.6a2.181,2.181,0,0,1-.5.4c-.2.1-.4.2-.5,0a3.021,3.021,0,0,1-.3-.9l-.8-6.3,1.1-.6-.3-2.5-1.1.6-.4-3.1",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M428.4,373.3a7.165,7.165,0,0,1,.2-2.2,2.234,2.234,0,0,1,.7-1.2c.4-.2.6-.2.9.1a3.726,3.726,0,0,1,.5,1.6v.3l-2.3,1.4m.6-6.1a3.487,3.487,0,0,0-1.4,1.7,8.238,8.238,0,0,0-.7,2.9,14.6,14.6,0,0,0,.1,3.6v.3a6.865,6.865,0,0,0,1.4,4,1.747,1.747,0,0,0,2.4.4,3.531,3.531,0,0,0,1.3-1.4,6.9,6.9,0,0,0,.8-2.3l-1-1.4a3.218,3.218,0,0,1-1.3,2.3.9.9,0,0,1-1.1-.1,3,3,0,0,1-.7-1.7l3.9-2.4-.2-1.4a8.622,8.622,0,0,0-1.3-4.2,1.592,1.592,0,0,0-2.2-.3",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M438.3,356.9a4.077,4.077,0,0,0-1.7,2.1,15.751,15.751,0,0,0-.9,3.6,24.045,24.045,0,0,0,.1,4.6l.1,1a11.844,11.844,0,0,0,1.7,5.5,1.934,1.934,0,0,0,2.8.7,5.4,5.4,0,0,0,2.2-3,12.771,12.771,0,0,0,.5-4.9l-1.7,1a6.856,6.856,0,0,1-.2,2.6,3.269,3.269,0,0,1-1.1,1.5c-.6.4-1.1.2-1.4-.5a11,11,0,0,1-.9-3.8l-.2-1.3a14.477,14.477,0,0,1,0-4.2,2.943,2.943,0,0,1,1.1-2,1.049,1.049,0,0,1,1.3,0,3.892,3.892,0,0,1,.7,2.1l1.7-1a6.415,6.415,0,0,0-1.6-3.8,1.832,1.832,0,0,0-2.5-.2",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M447.1,367.5a.786.786,0,0,1-1.1-.4,11.236,11.236,0,0,1-.7-5.8,1.818,1.818,0,0,1,.8-1.5.786.786,0,0,1,1.1.4,8.537,8.537,0,0,1,.7,2.5,8.382,8.382,0,0,1,0,3.2,2.226,2.226,0,0,1-.8,1.6m-1.3-10.4a3.413,3.413,0,0,0-1.4,1.7,8.238,8.238,0,0,0-.7,2.9,14.716,14.716,0,0,0,.1,3.6v.1a8,8,0,0,0,1.4,4.3,1.669,1.669,0,0,0,2.3.5,4.51,4.51,0,0,0,1.9-3,12.638,12.638,0,0,0,.2-5.2l-.1-.9a6.792,6.792,0,0,0-1.4-3.7,1.7,1.7,0,0,0-2.3-.3",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M456.6,350.6a4.318,4.318,0,0,0-1.6,3c-.5-1.1-1.1-1.4-1.9-1a4.169,4.169,0,0,0-1.6,2.7l-.2-1.4-1.5.9,1.5,12.7,1.6-1-1.1-9a2.239,2.239,0,0,1,.9-1.8.521.521,0,0,1,.8.1,3.023,3.023,0,0,1,.4,1.5l1,8.1,1.6-1-1.1-8.7a2.958,2.958,0,0,1,.8-2.1.521.521,0,0,1,.8.1,3.023,3.023,0,0,1,.4,1.5l1,8.1,1.7-1-1-8.1a8.3,8.3,0,0,0-.9-3.3,1.044,1.044,0,0,0-1.6-.3",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M463.9,357.4q-.75.45-1.2-.6l-.6-5.2a2.644,2.644,0,0,1,.9-1.9c.4-.2.7-.1,1,.4a6.492,6.492,0,0,1,.6,2.5c.3,2.8.1,4.3-.7,4.8m-.9-10.7a3.933,3.933,0,0,0-1.4,2.4l-.2-1.2-1.5.9,2.1,17.6,1.6-1-.7-6a1.12,1.12,0,0,0,1.7.4,4.131,4.131,0,0,0,1.5-2.8,16.922,16.922,0,0,0,.1-5.1v-.2a10.146,10.146,0,0,0-1.2-4.4,1.408,1.408,0,0,0-2-.6",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M469.9,353.9c-.3.2-.5.1-.6-.1a1.222,1.222,0,0,1-.3-.9v-.2a2.445,2.445,0,0,1,1.1-2.5l.6-.4.3,2.2-.3,1.2c-.3.3-.5.6-.8.7m-.9-10.7a5.346,5.346,0,0,0-1.3,1.3,6.982,6.982,0,0,0-.8,2,8.3,8.3,0,0,0-.1,2.2l1.6-1a2.769,2.769,0,0,1,.1-1.3,1.242,1.242,0,0,1,.6-.8.521.521,0,0,1,.8.1,3.323,3.323,0,0,1,.4,1.3l.1.7-.8.5a4.751,4.751,0,0,0-2,2.4,7.872,7.872,0,0,0-.4,3.5,3.8,3.8,0,0,0,.9,2.4,1.226,1.226,0,0,0,1.6.2,3.957,3.957,0,0,0,1.4-2.3,6.218,6.218,0,0,0,.3,1l1.7-1v-.2a14.555,14.555,0,0,1-.6-2.6l-.7-5.5a4.631,4.631,0,0,0-1.1-2.9c-.3-.4-1-.5-1.7,0",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M476.1,338.9a4.176,4.176,0,0,0-1.6,2.8l-.2-1.4-1.6.9,1.5,12.7,1.6-1-1.1-8.9q.15-1.5.9-1.8c.4-.2.6-.2.8,0a2.91,2.91,0,0,1,.4,1.4l1,8.1,1.6-1-1-8.2a7.711,7.711,0,0,0-.9-3.2.834.834,0,0,0-1.4-.4",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M484.5,334.1l-1.8,1.1-.2,8.6-2.1-7.2-1.8,1.1,3.7,11.4-.1,1.2a3.73,3.73,0,0,1-.2,1.2,1.576,1.576,0,0,1-.7.7l-.3.1.3,2.6a2.353,2.353,0,0,0,.8-.2c.8-.5,1.4-1.7,1.5-3.6l.1-.7.8-16.3",
    fill: "#242424"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCompany);
export default __webpack_public_path__ + "static/media/create-company.d319f86e49cf80152e8be6de7a9b924a.svg";
export { ForwardRef as ReactComponent };